import { render, staticRenderFns } from "./Created.vue?vue&type=template&id=5c9b392e&scoped=true"
import script from "./Created.vue?vue&type=script&lang=js"
export * from "./Created.vue?vue&type=script&lang=js"
import style0 from "./Created.vue?vue&type=style&index=0&id=5c9b392e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9b392e",
  null
  
)

export default component.exports